import { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX, Play } from "lucide-react";

/* Handy-Reel: stumm Autoplay im Viewport, Ton per Klick, Poster + lazy. */
export const VideoReel = ({ src, poster, label, testId }) => {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) { el.play().then(() => setStarted(true)).catch(() => {}); }
        else { el.pause(); }
      },
      { threshold: 0.6 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const toggleSound = () => {
    const el = ref.current;
    if (!el) return;
    const next = !muted;
    el.muted = next;
    setMuted(next);
    if (!next) el.play().catch(() => {});
  };

  return (
    <div className="relative aspect-[9/16] w-full overflow-hidden rounded-[2rem] border-2 border-[#111] bg-black shadow-[8px_8px_0_#111]" data-testid={testId}>
      <video
        ref={ref}
        className="h-full w-full object-cover"
        poster={poster}
        src={src}
        muted={muted}
        loop
        playsInline
        preload="none"
        aria-label={label}
      />
      {!started && (
        <span className="pointer-events-none absolute inset-0 grid place-items-center">
          <span className="grid h-14 w-14 place-items-center rounded-full border-2 border-[#111] bg-[#FDD105] text-[#111] shadow-[3px_3px_0_#111]"><Play size={22} className="translate-x-0.5" /></span>
        </span>
      )}
      <button
        type="button"
        onClick={toggleSound}
        aria-label={muted ? "Ton an" : "Ton aus"}
        data-testid={testId ? `${testId}-sound` : undefined}
        className="absolute bottom-3 right-3 grid h-10 w-10 place-items-center rounded-full border-2 border-white/80 bg-black/55 text-white backdrop-blur transition-transform hover:scale-105"
      >
        {muted ? <VolumeX size={17} /> : <Volume2 size={17} />}
      </button>
      {label && <span className="absolute left-3 top-3 rounded-full border border-[#111] bg-[#FDD105] px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-[#111]">{label}</span>}
    </div>
  );
};

export default VideoReel;
